export { default as IconB2PLogo } from './b2p-logo.svg';
export { default as IconMastercardLogo } from './mastercard-logo.svg';
export { default as IconMirLogo } from './mir-logo.svg';
export { default as IconVisaLogo } from './visa-logo.svg';
